import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHome = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 13v7h4v-7h-4zm6 7h3a1 1 0 0 0 1-1v-9a1 1 0 0 0-.355-.764l-.005-.005-6.997-5.998a1 1 0 0 0-1.286 0L4.36 9.231l-.006.005A1 1 0 0 0 4 10v9a1 1 0 0 0 1 1h3v-7a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v7zm6-1a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-9a3 3 0 0 1 1.063-2.292l6.995-5.995.005-.005a3 3 0 0 1 3.77-.083l.104.083.005.005 6.994 5.995A3.002 3.002 0 0 1 22 10v9z",
		fill: "currentColor"
	})
});
export default SvgHome;
